import { KnowledgeBaseType, KnowledgeBaseTypeWithItems, SearchPage } from '@edwin-group/people-graphql';
import { create } from 'zustand';

export interface ListingFilters {
  searchTerm?: string;
  contentTypes?: string[];
}

type KnowledgeBaseTypeFilter = KnowledgeBaseType | KnowledgeBaseTypeWithItems;

interface SearchingState {
  filters: ListingFilters;
  searchPage: { searchPage: SearchPage | null; knowledgeBaseTypes: KnowledgeBaseTypeFilter[] };
  fixedTypes: string[];
  page: number;
  updateFilters: (filters: ListingFilters) => void;
  setSearchPage: (searchPage: SearchPage, knowledgeBaseTypes: KnowledgeBaseTypeFilter[]) => void;
  handleToggleFilter: (field: keyof ListingFilters, value: string) => void;
  clearFilters: () => void;
  setPage: (page: number) => void;
}

export const useSearchingStore = create<SearchingState>((set, get) => ({
  filters: {
    searchTerm: '',
    contentTypes: [],
  },
  fixedTypes: ['Courses', 'Podcasts', 'Resources'],
  searchPage: { searchPage: null, knowledgeBaseTypes: [] },
  page: 1,
  setSearchPage: (searchPage, knowledgeBaseTypes) => {
    set({ searchPage: { searchPage, knowledgeBaseTypes } });
  },
  updateFilters: (filters: ListingFilters) => {
    set({
      filters,
      page: 1,
    });
  },
  handleToggleFilter: (field: keyof ListingFilters, value: string) => {
    const filters = get().filters;
    const currentArray = (filters[field] as string[]) || [];
    const isSelected = currentArray.includes(value);
    const newArray = isSelected ? currentArray.filter((item) => item !== value) : [...currentArray, value];
    const newFilters = { ...filters, [field]: newArray };
    set({
      filters: newFilters,
      page: 1,
    });
  },
  clearFilters: () => {
    set({
      filters: {
        searchTerm: '',
        contentTypes: [],
      },
      page: 1,
    });
  },
  setPage: (page: number) => {
    set({ page });
  },
}));
